<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
              :showBtn="false"
              :showAddNew="false"
              title="Opening Stock Import List"
            >
            <template #extra-btn>
              <a
                  download
                  href="/file/opening-stock-import-file.xlsx"
                  class="btn btn-outline-secondary waves-effect waves-float waves-light"
              >Download Sample
              </a>
            </template>
          </TitleButton>
            <input type="file" class="d-none" ref="uploader" @change="handleFileUpload">
        </div>

        <div class="row p-2">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
              <label class="align-middle">Warehouse</label>
              <v-select
                  placeholder="Select Warehouse"
                  v-model="warehouseId"
                  :options="warehouses"
                  label="text"
                  :reduce="text => text.id"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
              <label class="align-middle">Adjustment Account</label>
              <v-select
                  placeholder="Select Account Head"
                  v-model="accountHeadId"
                  :options="accountHeads"
                  label="name"
                  :reduce="name => name.id"
              />
            </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-2">
            <label class="align-middle">Adjustment Date</label>
            <input type="date" class="form-control" v-model="adjustmentDate">
          </div>

            <div v-if="warehouseId && accountHeadId && adjustmentDate" class="col-12 col-sm-6 col-md-4 col-lg-2 mt-auto">
                <button @click="uploadCsv" class="btn btn-primary waves-effect waves-float waves-light">
                    Browse
                </button>
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-2 mt-auto">
                <button @click="getCsvRow" class="btn btn-primary waves-effect waves-float waves-light">
                    Get CSV
                </button>
            </div>
        </div>

        <div class="p-2">
            <div v-for="(item, index) in csvRow" :key="index">
                <div class="py-1 bg-black-light rounded-8 mb-2 d-flex justify-content-between align-items-center">
                    <span class="cursor-pointer px-1" @click="gotoUpload(item.id)">id: {{ item.id }} Dataset: {{ item.batch }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted, watch, inject } from 'vue';
    import {useRoute, useRouter} from 'vue-router';
    import handleInventory from "@/services/modules/inventory";
    import handleBusinessesLocations from "@/services/modules/businessesLocations";
    import TitleButton from '@/components/atom/TitleButton.vue';
    import handleJournal from "@/services/modules/journal";
    import handleStock   from "@/services/modules/stock";

    const route = useRoute();
    const router = useRouter();
    const {  fetchHome } = handleInventory();
    const { uploadCsvFile, fetchCsvRow } = handleStock();
    const {fetchBusinessLocationsList} = handleBusinessesLocations();
    const {fetchAccountHeadsList} = handleJournal();

    const selectedFile = ref(null);
    const fileName = ref('');
    const uploader = ref(null);
    const uploadLog = ref([]);
    let warehouses = ref([])
    let accountHeads = ref([])
    let warehouseId = ref(null)
    let accountHeadId = ref(null)
    let adjustmentDate = ref(null)
    const product_type = ref(null);
    const csvRow = ref([]);
    const showError = inject('showError');
    const showSuccess = inject('showSuccess');

    onMounted(() => {
        let query = `?company_id=${route.params.companyId}`;
        let accountHeadQuery = query + '&cash_bank_hide=yes&status=active';
        adjustmentDate.value = new Date().toISOString().split('T')[0]

        Promise.all([
            fetchBusinessLocationsList(query).then(res => {
              if (res.data) {
                warehouses.value = res.data;
              }
            }),
            fetchAccountHeadsList(accountHeadQuery).then(res => {
              if (res.data) {
                accountHeads.value = res.data;
              }
            }),
            getCsvRow()
        ]).catch(e => showError('Something went wrong'))
    })

    const uploadCsv = () => {
        uploader.value.click();
    }

    const getCsvRow = () => {
        let query = `?company_id=${route.params.companyId}&type=opening_stock`;

        fetchCsvRow(query).then((res) => {
            if(!res.status) {
                return
            }
            showSuccess(res.message)
            csvRow.value = res.data
        }).catch(e => showError('Something went wrong'));
    }

    const gotoUpload = (id) => {
        route.query.rowId = id;
        router.push({name: 'upload-opening-stock', params: route.params, query: route.query});
    }

    const handleFileUpload = (event) => {
        selectedFile.value = event.target.files[0];
        fileName.value = event.target.files[0].fileName

        let fd = new FormData();
        fd.append('company_id', route.params.companyId)
        fd.append('sheet', selectedFile.value)
        fd.append('warehouse_id', warehouseId.value)
        fd.append('account_head_id', accountHeadId.value)
        fd.append('date', adjustmentDate.value)
        fd.append('type', 'opening_stock')
        
        uploadCsvFile(fd).then((res) => {
            if(!res.status) {
                showError(res.message)
                return
            }
            
            showSuccess(res.message)
            uploadLog.value = res.data
        }).catch(e => showError('Something went wrong'));
    }
</script>